import type {
  ImageSource,
  ImageTransform,
} from '@modules/_shared/components/image-upload/types';

export const isCurrentImageUnchanged = (
  source: ImageSource,
  transform: ImageTransform,
): boolean =>
  Boolean(
    source.metadata?.isCurrentImage && Object.keys(transform).length === 0,
  );
